import fiscalInstance from './instance'

export const getCashRegisterCloseZip = (dateFrom, dateTo) => {
	return fiscalInstance.get('/cashRegisterClose/zip?'
		+ (dateFrom ? 'dateFrom=' + dateFrom : '')
		+ (dateTo ? '&dateTo=' + dateTo : ''),
		{ responseType: 'arraybuffer' })
}

export const getOrderRegisterZip = (companyIndex, dateFrom, dateTo) =>
	fiscalInstance.get(
		`/${companyIndex}/orderRegisterEntries/zip`,
		{ params: { dateFrom, dateTo }, responseType: 'arraybuffer' },
	)

export default getCashRegisterCloseZip
